import React from "react";
import { useParams } from "react-router-dom";
import LogInComponent from "../../components/LogInComponent/LogInComponent";

const LogIn = ({ admin = false }) => {
  const { LogInId } = useParams();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-canvas px-4 py-10">
      <img src="/cb_logo.png" alt="ClientBloom Logo" className="mb-6 h-12" />
      <LogInComponent admin={admin} />
    </div>
  );
};

export default LogIn;
